import { apiClient } from './client';

export interface ExportsFilter {
  kind?: 'export' | 'gap_edit' | 'roll_read' | 'everything';
  days?: number | 'all';
  min_rows?: number;
  sort?: 'largest_first' | 'newest_first';
}

export interface AccessEntry {
  when: string;
  who: string;
  role: string;
  kind: string;
  area: string;
  rows: number;
  reason: string;
}

export interface ExportsResult {
  rows: AccessEntry[];
  total_rows: number;
  access_events: number;
  people_disclosed: number;
  distinct_users: number;
  largest_single: number;
}

export const exportsApi = {
  async getExports(filter: ExportsFilter = {}): Promise<ExportsResult> {
    const params = new URLSearchParams();
    params.append('kind', filter.kind || 'everything');
    params.append('days', filter.days === 'all' ? 'all' : String(filter.days ?? 30));
    params.append('min_rows', String(filter.min_rows ?? 0));
    params.append('sort', filter.sort || 'largest_first');
    return apiClient.get(`/exports/?${params.toString()}`);
  },
};
